module.exports = __webpack_public_path__ + "static/offline-992b780986507d6c23cf54d8d82b6a30.jpg";